import { Component, Input, OnInit } from "@angular/core";
import { SdpIcon } from "./models";
import { GatewayView } from "app/administrative/gateways/gateway-view";

@Component({
	selector: "sdp-icon",
	templateUrl: "./icon.component.html"
})
export class IconComponent implements OnInit {
	@Input()
	public icon!: SdpIcon.Icon | (() => Promise<SdpIcon.Icon | undefined>) | undefined;

	@Input()
	public row!: any;

	public async ngOnInit() {
		if (typeof this.icon === "function") {
			this.icon = await this.icon();
		}
	}

	public get name(): string | undefined {
		if (typeof this.icon === "function" || typeof this.icon === "undefined") {
			return undefined;
		}
		if (typeof this.icon.name === "function") {
			return this.icon.name(this.row);
		}
		return this.icon.name;
	}

	public get cssClass(): string | undefined {
		if (typeof this.icon === "function" || typeof this.icon === "undefined") {
			return undefined;
		}
		if (typeof this.icon.cssClass === "function") {
			return this.icon.cssClass(this.row);
		}
		return this.icon.cssClass;
	}

	public get logoName(): string | undefined {
		if (typeof this.icon === "function" || typeof this.icon === "undefined") {
			return undefined;
		}
		if (!this.icon.logo) {
			return undefined;
		}
		if (typeof this.icon.logo.name === "function") {
			return this.icon.logo.name(this.row);
		}
		return this.icon.logo.name;
	}

	public get logoCssClass(): string | undefined {
		if (typeof this.icon === "function" || typeof this.icon === "undefined") {
			return undefined;
		}
		if (!this.icon.logo) {
			return undefined;
		}
		if (typeof this.icon.logo.cssClass === "function") {
			return this.icon.logo.cssClass(this.row);
		}
		return this.icon.logo.cssClass;
	}
}
